export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/constant.js
// module id = 2
// module chunks = 0